import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

let interval;
const UXAudio = new Audio();

const MainProgressBar = (props) => {
  let [val, setVal] = useState(0);

  useEffect(() => {
    console.log("props.value", props.value);
    if (props.value) {
      let localVal = 0;
      UXEffect();

      if (props.noanimation) {
        setVal(props.value);
      } else {
        interval = setInterval(() => {
          console.log("SDFC", +localVal >= +props.value);
          if (+localVal >= +props.value) {
            clearInterval(interval);
            return false;
          }
          localVal++;
          setVal(localVal);
        }, [10]);
      }
    }

    return () => {
      clearInterval(interval);
      UXAudio.pause();
      UXAudio.currentTime = 0;
    };
  }, [props.value]);

  const UXEffect = (src) => {
    UXAudio.src = require('../../assets/audio/progress.mp3');
    let playPromise = UXAudio.play();
    if (playPromise !== undefined) {
      playPromise
        .then((_) => {
          // Automatic playback started!
          // Show playing UI.
        })
        .catch((error) => {
          // Auto-play was prevented
          // Show paused UI.
        });
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1, position: "relative" }}>
        {val && (
          <>
            <LinearProgress
              variant="determinate"
              color={
                val >= 0 && val < 20
                  ? "progresserror"
                  : val >= 20 && val <= 50
                  ? "progress"
                  : "progresssuccess"
              }
              sx={{
                height: "30px",
                borderRadius: 25,
                backgroundColor:
                  val >= 0 && val < 20
                    ? "#FFCCCF"
                    : val >= 20 && val <= 50
                    ? "#9ab2d3"
                    : "#CCE8C5",
              }}
              value={val}
            />
            <Box sx={{ minWidth: 35, position: "absolute", top: 0, right: 20 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  color: "#FFFFFF",
                }}
              >{`${val}%`}</Typography>
            </Box>
            <Box sx={{ minWidth: 35, position: "absolute", top: 9, left: 20 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: "1rem", color: "#FFFFFF" }}
              >
                {props.text ? props.text : ""}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default MainProgressBar;
